function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "w0qU";


//////////////////
// WEBPACK FOOTER
// ./src/views router\.js$
// module id = w0qU
// module chunks = 1